import React, { useState } from 'react';
import { Modal, Button, Row, Col, Table, Badge, Tabs, Tab } from 'react-bootstrap';

const InterviewDetailsModal = ({ 
  show, 
  handleClose, 
  interview, 
  formatTime, 
  formatDate 
}) => {
  const [activeTab, setActiveTab] = useState(0);
  
  if (!interview) return null;
  
  // Handle array of interviews or single interview
  const interviews = Array.isArray(interview) ? interview : [interview];
  const currentInterview = interviews[activeTab];
  
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Interview Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {interviews.length > 1 && (
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(Number(k))}
            className="interview-tabs mb-3"
          >
            {interviews.map((interview, index) => (
              <Tab 
                key={interview.id} 
                eventKey={index} 
                title={`${interview.student.name} - Panel ${interview.panel.number}`}
              />
            ))}
          </Tabs>
        )}
        
        <Row className="mb-3">
          <Col md={6}>
            <h5>Student Information</h5>
            <Table bordered size="sm">
              <tbody>
                <tr>
                  <th width="30%">Name</th>
                  <td>{currentInterview.student.name}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{currentInterview.student.email}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
          <Col md={6}>
            <h5>Company & Panel</h5>
            <Table bordered size="sm">
              <tbody>
                <tr>
                  <th width="30%">Company</th>
                  <td>{currentInterview.company.name}</td>
                </tr>
                <tr>
                  <th>Round</th>
                  <td>Round {currentInterview.round.number}</td>
                </tr>
                <tr>
                  <th>Panel</th>
                  <td>Panel {currentInterview.panel.number}</td>
                </tr>
                <tr>
                  <th>Interviewer</th>
                  <td>{currentInterview.panel.interviewer}</td>
                </tr>
                <tr>
                  <th>Location</th>
                  <td>{currentInterview.panel.place}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        
        <Row>
          <Col md={6}>
            <h5>Schedule</h5>
            <Table bordered size="sm">
              <tbody>
                <tr>
                  <th width="30%">Date</th>
                  <td>{formatDate(currentInterview.company.visit_date)}</td>
                </tr>
                <tr>
                  <th>Time</th>
                  <td>
                    {formatTime(currentInterview.time_slot.start_time)} - {formatTime(currentInterview.time_slot.end_time)}
                  </td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    <Badge bg={
                      currentInterview.status === 'SCHEDULED' ? 'primary' :
                      currentInterview.status === 'COMPLETED' ? 'success' :
                      currentInterview.status === 'ABSENT' ? 'warning' : 'danger'
                    }>
                      {currentInterview.status}
                    </Badge>
                  </td>
                </tr>
                {currentInterview.clash_type !== 'NONE' && (
                  <tr>
                    <th>Conflict</th>
                    <td className="text-danger">
                      {currentInterview.clash_type === 'GD' ? 'Group Discussion Clash' :
                       currentInterview.clash_type === 'INTERVIEW' ? 'Another Interview Clash' :
                       currentInterview.clash_type === 'PANEL' ? 'Panel Timing Clash' : 'Unknown Conflict'}
                      {currentInterview.clash_details && (
                        <div className="small">{currentInterview.clash_details}</div>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
          <Col md={6}>
            <h5>Actions</h5>
            <div className="d-grid gap-2">
              <Button variant="primary" size="sm">
                Update Status
              </Button>
              <Button variant="warning" size="sm">
                Reschedule Interview
              </Button>
              <Button variant="danger" size="sm">
                Cancel Interview
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InterviewDetailsModal;